export default "__VITE_ASSET__3d0b60ee__"